/* eslint-disable max-len */

/**
 * Иеонка тегов
 */
export const TagIcon = () => {
  /**
   * Рендер компонента
   */
  const renderContent = () => (
    <svg width='20' height='20' viewBox='0 0 20 20' fill='currentColor' xmlns='http://www.w3.org/2000/svg'>
      <path fillRule='evenodd'
            clipRule='evenodd'
            d='M11.575 18.75C11.0779 18.7496 10.6013 18.5517 10.25 18.2L1.8 9.75625C1.44827 9.40496 1.25044 8.92836
             1.25 8.43125V3.125C1.25 2.08947 2.08947 1.25 3.125 1.25H8.43125C8.92836 1.25044 9.40496 1.44827 9.75625
              1.8L18.2 10.2437C18.553 10.5956 18.7515 11.0735 18.7515 11.5719C18.7515 12.0703 18.553 12.5482 18.2
              12.9L12.9 18.2C12.5487 18.5517 12.0721 18.7496 11.575 18.75ZM5 7.5C5 8.88071 6.11929 10 7.5 10C8.88071
               10 10 8.88071 10 7.5C10 6.11929 8.88071 5 7.5 5C6.11929 5 5 6.11929 5 7.5ZM6.25 7.5C6.25 6.80964
                6.80964 6.25 7.5 6.25C8.19036 6.25 8.75 6.80964 8.75 7.5C8.75 8.19036 8.19036 8.75 7.5 8.75C6.80964
                 8.75 6.25 8.19036 6.25 7.5ZM2.5 3.125C2.5 2.77982 2.77982 2.5 3.125 2.5H8.43125C8.59828 2.50069
                  8.75808 2.56822 8.875 2.6875L17.3188 11.1313C17.5611 11.375 17.5611 11.7687 17.3188 12.0125L12.0125
                   17.3188C11.7687 17.5611 11.375 17.5611 11.1313 17.3188L2.6875 8.875C2.56822 8.75808
                    2.50069 8.59828 2.5 8.43125V3.125Z'
            fill='currentColor' />
    </svg>
  );

  return renderContent();
};
